<template>
    <div>
        <div class="main-nav-top">
            <a class="main-nav-menu" @click="openNav()" v-show="is_logged_in">
                <img style="pointer-events: none;" :src="icons.hamburger" alt="" />
            </a>
            <a class="main-nav-logo" :href="public_url">
                <img :src="icons.weplan_logo" alt="" />
            </a>
            <div class="search"></div>
        </div>

        <div id="sidenav" :class="{ sidenav: true, slide: slide }" v-click-outside="onClickOutsideOfMenu">
            <a href="javascript:{}" class="icon-close" @click="closeNav()"></a>
            <div class="sidenav-links">
                <a @click="link_clicked('about', $event)" href="javascript:{}">
                    <span class="icon-hot"></span>
                    About
                </a>
                <a @click="link_clicked('support', $event)" href="javascript:{}">
                    <span class="icon-hot"></span>Support
                </a>
                <a @click="link_clicked('privacy-policy', $event)" href="javascript:{}">
                    <span class="icon-hot"></span>Terms & Privacy policy</a
                >
                <div class="menu-separator"></div>

                <a @click="link_clicked('settings', $event)" href="javascript:{}">
                    <span class="icon-settings"></span>Settings</a
                >

                <a class="logout" @click="logout_user" href="javascript:{}">
                    <span class="icon-logout"></span>
                    Log out
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import settings from "@/settings";
import { mapActions, mapState } from "vuex";
import vClickOutside from "v-click-outside";
import router from "@/router";

export default {
    name: "sidemenu",
    data() {
        return {
            side_menu_shown: true,
            slide: false,
            public_url: settings.public_url,
            icons: {
                hamburger: settings.assets_url + "/static/img/Hamburger-line.svg",
                weplan_logo: settings.assets_url + "/static/img/weplan.svg"
            }
        };
    },
    created() {},
    //mixins: [clickaway],

    computed: {
        ...mapState(["user"]),
        ...mapState("StoreEvent", ["errors"]),
        ...mapState("StoreEvent", ["event"]),
        ...mapState(["is_logged_in"])
    },
    directives: {
        clickOutside: vClickOutside.directive
    },
    methods: {
        ...mapActions(["user_logout"]),
        logout_user() {
            this.user_logout();
            this.closeNav();
        },
        go_to_public() {
            window.location = this.public_url;
        },
        onClickOutsideOfMenu(event) {
            if (this.side_menu_shown && !event.target.classList.contains("main-nav-menu")) {
                this.closeNav();
            }
        },
        link_clicked(tab = false, e) {
            e.stopPropagation();
            if (tab) {
                this.closeNav();
                router.push({ path: "/" + tab });
            }
        },
        openNav() {
            this.slide = !this.slide;
            setTimeout(() => {
                this.side_menu_shown = !this.side_menu_shown;
            }, 200);
        },
        closeNav() {
            this.slide = false;
            this.side_menu_shown = false;
        }
    }
};
</script>

<style scoped>
.menu-separator {
    margin: 0rem 2.4rem 2.4rem 2rem;
}
</style>
